import {getLocation, setLastSearchCityLabel, translate} from "./utils.esm";
import {submitSearchFormHandler} from "./search";

export const autocompleteFn = {
    homeAutocompleteItems: [],
    hideHomeAutocomplete() {
        document.querySelectorAll('.home-autocomplete').forEach(autocomplete => autocomplete.classList.add('d-none'));
    },
    simulateSubmitSearchFormHandler(noResults = false) {
        const customEvent = {
            preventDefault: false,
            target: document.querySelector('form button[type="submit"]'),
        };
        submitSearchFormHandler(
            noResults,
            customEvent,
            'home_last_search_form',
            setLastSearchCityLabel
        );
    },
    simulateHomeAutocompleteItemClickHandler(event, items) {
        if(items.length === 0) {
            this.simulateSubmitSearchFormHandler(true);
            return false;
        }
        const item = items[0];
        this.homeAutocompleteItemClickHandler(event, item.text, item.type, item.id);
    },
    stripHTMLTags(text) {
        return text.replace(/(<([^>]+)>)/gi, "");
    },
    homeAutocompleteItemClickHandler(event, text, tipo, id) {
        if(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        autocompleteFn.disableHomeSubmitBtn();

        const cityInput = document.querySelector('.Search_city_id');
        const areaInput = document.querySelector('.Search_area_id');

        cityInput.value = '';
        areaInput.value = '';

        let refEl;
        switch (tipo) {
            case 'country':
                break;
            case 'ciudad':
                refEl = cityInput;
                break;
            case 'area':
                refEl = areaInput;
                break;
        }
        if(refEl) refEl.value = id;

        document.querySelector('#main-search-nombre').value = this.stripHTMLTags(text);
        document.querySelector('.Search_location_name').value = this.stripHTMLTags(text);
        this.hideHomeAutocomplete();
        autocompleteFn.simulateSubmitSearchFormHandler(false);
    },
    fillHomeAutocomplete(items, value, container = undefined, inputEl = '.main-search-input input', customFillHTMLFunc = false) {
        return new Promise((resolve) => {
            document.querySelectorAll('.autocomplete-item').forEach(item => item.remove());

            const autocomplete = container ? container : document.querySelector('.home-autocomplete');

            const noResults = autocomplete.querySelector('.autocomplete-no-results');
            if(noResults) noResults.classList.remove('active');
            autocomplete.classList.remove('show-nearby');

            if(noResults && items.length === 0 && value.length > 0) {
                noResults.classList.add('active');
            } else if(!customFillHTMLFunc && value.length === 0) {
                autocomplete.classList.add('show-nearby');
                resolve(autocomplete);
            }

            resolve(autocomplete);
        });
    },
    showHomeSearchMapInputError() {
        document.querySelectorAll('.main-search-input').forEach(input => input.classList.add('show-error'));
    },
    searchHomeMapFormSubmit() {
        autocompleteFn.hideHomeSearchMapInputError();
        document.querySelector('form[action="/search"]').submit();
    },
    hideHomeSearchMapInputError() {
        document.querySelectorAll('.main-search-input').forEach(input => input.classList.remove('show-error'));
    },
    async homeNearByBtn(selector) {
        this.disableHomeSubmitBtn();
        await getLocation();
        autocompleteFn.searchHomeMapFormSubmit();
        translate({str: 'Perto de mim', element: document.querySelector(selector)});
    },
    disableHomeSubmitBtn() {
        if(this.el) this.el.setAttribute('disabled', 'true');
    },
    homeAutocompleteSetTipo(tipo) {
        document.querySelectorAll('#main-search-tipo > div').forEach(input => input.classList.remove('active'));
        const el = document.querySelector('#main-search-tipo > div[data-value="'+tipo+'"]');
        el.classList.add('active');

        document.querySelector('input[name="Search[type_id]"]').value = tipo;
    },
    checkHomeSearchInputError(event, selector) {
        const value = document.querySelector(selector).value;
        if(value.length === 0 ) autocompleteFn.showHomeSearchMapInputError();
        else if(autocompleteFn.homeAutocompleteItems.length === 0) autocompleteFn.showHomeSearchMapInputError(); // autocompleteFn.simulateSubmitSearchFormHandler(true);
        else autocompleteFn.simulateHomeAutocompleteItemClickHandler(undefined, autocompleteFn.homeAutocompleteItems);
    }
};
